import { Cart, CartContents } from "./cart";

/*
 * Adds dynamic functionality to the navbar such as cart quantity updates, menu bar interactions.
 */
export class Navbar {
    constructor() {

    }

	setupNavbar() {
		this.setupNavMenu();
		this.setupCartQuantity();
	}

    async setupCartQuantity() {
        // Update cart quantity when the cart is updated
        const cart = Cart.getInstance();

		try {
			const cartId = await cart.getOrCreateCart();
			const cartContents = await cart.getCart(cartId);
			this.updateCartQuantity(cartContents);

            // Now we that we have updated the cart manually once, we can listen for future updates
            cart.cartEvents.addCartUpdatedListener((cartUpdatedEvt) => {
                this.updateCartQuantity(cartUpdatedEvt.cartContents);
            });

		} catch (error) {
			console.error("Error fetching cart contents:", error);
		}
    }

	updateCartQuantity(cartContents: CartContents) {
		const cartCountElement = document.getElementById('nav-cart-count');

		if(!cartCountElement) {
			throw new Error("Cart count element with id='nav-cart-count' not found");
		}

        const  cartItemCount = cartContents.lineItems.reduce((total, item) => total + item.quantity, 0);
        if(cartItemCount > 0) {
            cartCountElement.textContent = cartItemCount.toString();
            cartCountElement.classList.add('active');
        } else {
            cartCountElement.textContent = '0';
            cartCountElement.classList.remove('active');
        }
	}

	setupNavMenu() {
		const hamburger = document.getElementById('hamburger');

		if(!hamburger) {
			throw new Error("Hamburger element with id='hamburger' not found");
		}

        const navLinks = document.getElementById('navLinks');

        if(!navLinks) {
            throw new Error("Nav links element with id='navLinks' not found");
        }

        // On mouse hover over any nav-section that is a direct child of nav-links, open the details element
        const topLevelSections = document.querySelectorAll('.nav-links > details.nav-section');

        topLevelSections.forEach(section => {
            section.addEventListener('mouseover', () => {
                // Only set attribute if hamburger is display:none (desktop view)
                if (getComputedStyle(hamburger).display === 'none') {
                    section.setAttribute('open', "");
                    // Find any child elements of `section` that are details elements and set them to open as well
                    const childSections = section.querySelectorAll('details.nav-section');
                    childSections.forEach(childSection => {
                        childSection.setAttribute('open', "");
                    });
                }
            });
            section.addEventListener('mouseout', () => {
                // Only remove attribute if hamburger is display:none (desktop view)
                if (getComputedStyle(hamburger).display === 'none') {
                    section.removeAttribute('open');
                    // Find any child elements of `section` that are details elements and remove the open attribute as well
                    const childSections = section.querySelectorAll('details.nav-section');
                    childSections.forEach(childSection => {
                        childSection.removeAttribute('open');
                    });
                }
            });
        });

        // Add event listeners to all details elements to prevent them from closing when in desktop mode clicked
        const allDetails = document.querySelectorAll('details.nav-section');
        allDetails.forEach(details => {
            details.addEventListener('click', (e) => {
                // Check if the hamburger is not displayed (desktop view)
                if (getComputedStyle(hamburger).display === 'none') {
					if(e.target === null) {
						return;
					}
					if(!(e.target instanceof HTMLElement)) {
						return;
					}
                    // If link is clicked, allow that, otherwise prevent default action (e.g. toggle open/close)
                    if (e.target.tagName === 'A') {
                        return;
                    }
                    e.preventDefault();
                }
                // else {
                //     // In mobile view, prevent clicking a tags, but still allow the toggle of the details element
                //     if (e.target.tagName === 'A') {
                //         e.preventDefault();
                //     }
                //     // Allow the details element to toggle open/close
                //     details.toggleAttribute('open');
                // }
            });
        });

        hamburger.addEventListener('click', () => {
            navLinks.classList.toggle('show');
        });
	}
}